import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';


const Unicef = () => (
  <Fragment>
    <Header headerName="Envio de recorrência - UNICEF" />
    <div className="container-fluid mt--6">
      <div className="row">
        <div className="col-xl-12 order-xl-1">
          <Card />
        </div>
      </div>
    </div>
  </Fragment>
)

export default Unicef;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/index.js